import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
            <img src="/logo.png" alt="Ansuvara Group" className="logo-image" />
            </div>
            <div className="social-links">
              <a href="https://facebook.com/ansuvara" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://linkedin.com/company/ansuvara" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://twitter.com/ansuvara" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://instagram.com/ansuvara" target="_blank" rel="noopener noreferrer" className="social-link">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>

          <div className="footer-section">
           
          </div>

          <div className="footer-section">
            
          </div>

          <div className="footer-section">
            <h4>Connect With Us</h4>
            <div className="contact-info">
              <p>Nayabazar, Pokhara, Nepal</p>
              <p>Phone: +977 61 521206</p>
              <p>Email: info@ansuvaragroup.com</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Ansuvara Group. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
              <a href="/cookie-policy">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 